import ScoreHistory from "./ScoreHistory";

export default ScoreHistory;
